import { ListIteratee, orderBy } from "lodash"
import { useMemo } from "react"

// Provides a filtered and sorted view based on the passed `items`.
export function useFilteredSortedData<T>({
  items,
  sortDirection,

  filterBy,
  sortBy,
}: {
  items: T[]
  sortDirection: "asc" | "desc"

  filterBy?: (item: T) => boolean
  sortBy?: ListIteratee<T> | ListIteratee<T>[]
}): T[] {
  const resultItems = useMemo(() => {
    // Apply a filter on the received `items` if one is defined...
    const filteredItems = filterBy ? items.filter(filterBy) : items

    // ...AND/OR apply a potential sort on the optionally filtered `items`.
    return sortBy ? orderBy(filteredItems, sortBy) : filteredItems
  }, [filterBy, items, sortBy])

  // If the specified `sortDirection` asks for it,
  // reverse the order of the evaluated `resultItems`.
  return useMemo(
    () => (sortDirection == "desc" ? resultItems.toReversed() : resultItems),
    [resultItems, sortDirection],
  )
}
